/* <fit-text>: sizes a single line of text to fill its parent's width (§9 giant wordmark).
   Measures once at 100px, scales, and re-fits on resize and once web fonts have loaded. */
class FitText extends HTMLElement {
  connectedCallback() {
    this.fit = this.fit.bind(this);
    this.resizeObserver = new ResizeObserver(() => this.fit());
    this.resizeObserver.observe(this.parentElement);
    if (document.fonts) document.fonts.ready.then(this.fit);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  fit() {
    const parent = this.parentElement;
    const styles = getComputedStyle(parent);
    const available = parent.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
    this.style.setProperty('--fs', '100px');
    const width = this.getBoundingClientRect().width;
    if (!width || available <= 0) return;
    this.style.setProperty('--fs', `${((100 * available) / width).toFixed(2)}px`);
  }
}

if (!customElements.get('fit-text')) customElements.define('fit-text', FitText);
